var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.5 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.375 1H10.6875V0.5C10.6875 0.367392 10.6282 0.240215 10.5227 0.146447C10.4173 0.0526784 10.2742 0 10.125 0C9.97582 0 9.83274 0.0526784 9.72725 0.146447C9.62176 0.240215 9.5625 0.367392 9.5625 0.5V1H3.9375V0.5C3.9375 0.367392 3.87824 0.240215 3.77275 0.146447C3.66726 0.0526784 3.52418 0 3.375 0C3.22582 0 3.08274 0.0526784 2.97725 0.146447C2.87176 0.240215 2.8125 0.367392 2.8125 0.5V1H1.125C0.826631 1 0.540483 1.10536 0.329505 1.29289C0.118526 1.48043 0 1.73478 0 2V12C0 12.2652 0.118526 12.5196 0.329505 12.7071C0.540483 12.8946 0.826631 13 1.125 13H12.375C12.6734 13 12.9595 12.8946 13.1705 12.7071C13.3815 12.5196 13.5 12.2652 13.5 12V2C13.5 1.73478 13.3815 1.48043 13.1705 1.29289C12.9595 1.10536 12.6734 1 12.375 1ZM2.8125 2V2.5C2.8125 2.63261 2.87176 2.75979 2.97725 2.85355C3.08274 2.94732 3.22582 3 3.375 3C3.52418 3 3.66726 2.94732 3.77275 2.85355C3.87824 2.75979 3.9375 2.63261 3.9375 2.5V2H9.5625V2.5C9.5625 2.63261 9.62176 2.75979 9.72725 2.85355C9.83274 2.94732 9.97582 3 10.125 3C10.2742 3 10.4173 2.94732 10.5227 2.85355C10.6282 2.75979 10.6875 2.63261 10.6875 2.5V2H12.375V4H1.125V2H2.8125ZM12.375 12H1.125V5H12.375V12Z",
    fill: "var(--fill-0, #101010)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlank);
export default __webpack_public_path__ + "static/media/calendar-blank.637142cc5651a0f1aeb2101313cf8b12.svg";
export { ForwardRef as ReactComponent };